/*
 * Feature toggles can be used to hide in progress features, but still
 * merge code into master.
 */

export const IS_PREMIUM_ENABLED = false;
export const IS_STYLING_ENABLED = true;

export function getIsPremiumEnabled() {
  return IS_PREMIUM_ENABLED;
}

export function getIsStylingEnabled() {
  return IS_STYLING_ENABLED;
}
